import { styled } from 'stitches.config'
import {
  ImageColumn,
  ImageContainer,
  RecipesContainer,
} from '../../../FreezeDriedBox/components/Hero/Hero.styles'

export const VenisonRecipesContainer = styled(RecipesContainer, {
  marginTop: '$3',
})

export const VenisonImageColumn = styled(ImageColumn, {
  '@bp2': {
    paddingTop: '72px',
  },
})

export const VenisonImageContainer = styled(ImageContainer, {
  aspectRatio: 'auto',

  '@bp2': {
    aspectRatio: 597 / 621,
  },
})
